import { type FC, useCallback, useContext } from "react";

import styled from "@emotion/styled";
import {
    Button,
    type ButtonType,
    Colors,
    type NotificationConfigProps,
    Tooltip,
    Notification,
} from "@snapchat/snap-design-system";
import { CopyIcon } from "@snapchat/snap-design-system-icons";

import { copyToClipboard } from "../../core/browser";

export const IconContainer = styled.div`
    margin-left: 8px;
    ${(props: { isSDSButton?: boolean }) =>
        !props.isSDSButton &&
        `
    .sds-base-button.ant-btn {
        background-color: transparent;
        padding: 0;
        box-shadow: none;
        min-height: auto;
    }
    .sds-base-button.ant-btn.default:hover {
        box-shadow: none;
    }
    `}
`;

export interface CopyToClipboardButtonProps {
    tooltip: string;
    copyValue: string;
    notification: NotificationConfigProps;
    buttonText?: string;
    buttonType?: ButtonType;
    testId?: string;
    iconSize?: number;
}

export const CopyToClipboardButton: FC<CopyToClipboardButtonProps> = ({
    tooltip,
    copyValue,
    notification,
    buttonText,
    buttonType,
    testId,
    iconSize = 12,
}) => {
    const notificationApi = useContext(Notification.Context);

    const handleCopy = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            copyToClipboard(copyValue);
            notificationApi.success(notification);
        },
        [copyValue, notification, notificationApi],
    );

    return (
        <Tooltip content={tooltip}>
            <IconContainer isSDSButton={(buttonType?.length ?? -1) > 0}>
                <Button
                    onClick={handleCopy}
                    data-testid={`${testId ? testId + "-" : ""}copy-to-clipboard`}
                    type={(buttonType?.length ?? -1) > 0 ? buttonType : "default"}
                >
                    <CopyIcon size={iconSize} fill={Colors.Black.V50} />
                    {buttonText && buttonText}
                </Button>
            </IconContainer>
        </Tooltip>
    );
};
